<template>
  <transition name="fade">
    <div v-if="show" class="modern-update-overlay" @click.self="close">
      <div class="modern-update-card">
        <div class="update-header">
          <div class="sparkle-icon">✨</div>
          <h3>تحديثات النظام الجديدة ({{ version }})</h3>
          <p>أحدث التحسينات والمميزات التي تم إضافتها</p>
        </div>
        
        <div class="update-body">
          <div v-for="(update, index) in recentUpdates" :key="index" class="feature-item">
            <div class="feature-bullet">{{ update.icon }}</div>
            <div class="feature-content">
              <h4>{{ update.title }}</h4>
            </div>
          </div>
        </div>

        <div class="update-footer">
          <button @click="viewAllUpdates" class="btn-view-all">
            📋 عرض كافة التفاصيل
          </button>
          <button @click="close" class="btn-got-it">إغلاق</button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { UPDATES_LOG } from '@/constants/updates';

export default {
  data() {
    return {
      show: false,
      updates: UPDATES_LOG,
      version: '...'
    };
  },
  computed: {
    recentUpdates() {
      return this.updates.slice(0, 3);
    }
  },
  async mounted() {
    // Disabled - modal will not show
    return;
  },
  methods: {
    close() {
      this.show = false;
      if (this.version && this.version !== '...') {
        localStorage.setItem('schoolna_updates_seen_version', this.version);
      }
    },
    viewAllUpdates() {
      this.close();
      this.$router.push('/updates');
    }
  }
};
</script>

<style scoped>
.modern-update-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(29, 81, 102, 0.4);
  backdrop-filter: blur(12px);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Cairo', sans-serif;
}

.modern-update-card {
  background: rgba(255, 255, 255, 0.98);
  width: 95%;
  max-width: 450px;
  max-height: 85vh;
  border-radius: 24px;
  padding: 24px;
  box-shadow: 0 25px 50px rgba(0,0,0,0.15);
  text-align: center;
  border: 1px solid rgba(255,255,255,0.8);
  overflow-y: auto;
}

.update-header h3 {
  color: #1d5166;
  font-weight: 800;
  margin-top: 8px;
  font-size: 20px;
}

.update-header p {
  color: #64748b;
  font-size: 15px;
  margin-bottom: 24px;
}

.sparkle-icon {
  font-size: 48px;
  animation: bounce 2s infinite;
}

@keyframes bounce {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-10px); }
}

.update-body {
  text-align: right;
  padding: 0 10px;
  max-height: 400px;
  overflow-y: auto;
}

.feature-item {
  display: flex;
  flex-direction: row-reverse;
  gap: 12px;
  margin-bottom: 12px;
  padding: 12px;
  border-radius: 12px;
  background: #f8fafb;
  transition: all 0.3s ease;
  border-right: 4px solid transparent;
}

.feature-item:hover {
  background: #f0f9ff;
  border-right-color: #1d5166;
  transform: translateX(-4px);
}

[dir="ltr"] .feature-item {
  border-right: none;
  border-left: 4px solid transparent;
}

[dir="ltr"] .feature-item:hover {
  border-left-color: #1d5166;
  transform: translateX(4px);
}

.feature-bullet {
  font-size: 24px;
  flex-shrink: 0;
}

.feature-content h4 {
  font-size: 15px;
  color: #1e293b;
  margin: 0;
  font-weight: 700;
  line-height: 1.4;
}

.update-footer {
  display: flex;
  gap: 12px;
  flex-direction: column;
  margin-top: 24px;
}

.btn-view-all {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  padding: 14px 50px;
  border-radius: 16px;
  font-weight: 700;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 10px 20px rgba(102, 126, 234, 0.3);
}

.btn-view-all:hover {
  transform: translateY(-3px);
  box-shadow: 0 15px 30px rgba(102, 126, 234, 0.4);
}

.btn-got-it {
  background: linear-gradient(135deg, #1d5166 0%, #0a2e3b 100%);
  color: white;
  border: none;
  padding: 14px 50px;
  border-radius: 16px;
  font-weight: 700;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 10px 20px rgba(29, 81, 102, 0.2);
}

.btn-got-it:hover {
  transform: translateY(-3px);
  box-shadow: 0 15px 30px rgba(29, 81, 102, 0.3);
}

.fade-enter-active, .fade-leave-active {
  transition: all 0.6s cubic-bezier(0.16, 1, 0.3, 1);
}
.fade-enter, .fade-leave-to {
  opacity: 0;
  transform: scale(0.9) translateY(30px);
}

/* Scrollbar Styling */
.update-body::-webkit-scrollbar {
  width: 6px;
}

.update-body::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 10px;
}

.update-body::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 10px;
}

.update-body::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}
</style>
